import PropTypes from 'prop-types';
import { Controller, useWatch } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Input from 'shopper/components/Input';
import Text from 'shopper/components/Text';

import { noop } from 'lib/utils';

const FormHeading = ({
  className,
  description,
  inputLetterCounter = false,
  inputProps,
  title,
}) => {
  const {
    control,
    defaultMessage,
    loading,
    label,
    maxLength,
    name,
    placeholder,
    rules,
    onChange = noop,
    onFocus = noop,
  } = inputProps;

  const inputContentLength = useWatch({ control, name }).length;

  return (
    <Box
      className={twMerge(
        'bg-primary-100 p-4 dark:bg-primary-500 md:p-6',
        className
      )}
    >
      <div className="mb-4 border-b-2 border-neutral-high-200 pb-4 dark:border-neutral-low-300">
        <Heading as="h1" className="mb-4" size="size4">
          {title}
        </Heading>
        <Text>{description}</Text>
      </div>
      <Controller
        control={control}
        name={name}
        render={({
          field: { onChange: onHookFormChange, ...fieldProps },
          fieldState: { error },
        }) => (
          <Input
            error={!!error}
            label={label}
            loading={loading}
            message={error?.message || defaultMessage}
            placeholder={placeholder}
            full
            required
            onChange={(event) => {
              onHookFormChange(event.target.value);
              onChange(event);
            }}
            onFocus={onFocus}
            {...fieldProps}
          />
        )}
        rules={rules}
      />
      {inputLetterCounter && (
        <div className="flex justify-end">
          <Text className="mt-1" size="size2">
            {inputContentLength}
            {`/${maxLength}`}
          </Text>
        </div>
      )}
    </Box>
  );
};

FormHeading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.string.isRequired,
  inputLetterCounter: PropTypes.bool,
  inputProps: PropTypes.shape({
    control: PropTypes.shape().isRequired,
    defaultMessage: PropTypes.string,
    iconRight: PropTypes.node,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    rules: PropTypes.shape().isRequired,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default FormHeading;
